export enum Actions {
  Update = 'update',
  View = 'View',
  Add = 'Add',
  Download = 'Download',
  EnableSetting = 'EnableSetting',
  UseFeature = 'UseFeature',
  Search = 'Search',
  Read = 'read',
  Create = 'create',
  Delete = 'delete',
}

export enum Subjects {
  AccountPassword = 'AccountPassword',
  TeamMember = 'TeamMember',
  TeamSSOBanner = 'TeamSSOBanner',
  Clips = 'Clips',
  Wav = 'wav',
  Ogg = 'ogg',
  Mp3 = 'mp3',
  Script = 'Script',
  GlobalAudioFileFormat = 'GlobalAudioFileFormat',
  MultipleTTSVersions = 'MultipleTTSVersions',
  Churnkey = 'Churnkey',
  Projects = 'projects',
  ThirdPartyVoices = 'ThirdPartyVoices',
  Workspace = 'Workspace',
  // [team_expansion]: todo - in followup, update frontend to use project library
  ProjectLibrary = 'ProjectLibrary',
  SharedLibrary = 'SharedLibrary',
  /**
   * Represents team voices
   */
  Voices = 'Voices',
  Captions = 'Captions',
  Comments = 'comments',
  Collaborator = 'Collaborator',
  /**
   * Workspaces
   */
  CustomWorkspace = 'custom_workspace',
  TeamWorkspace = 'team_workspace',
  PersonalWorkspace = 'personal_workspace',
  /**
   * Pages
   */
  PageIntegrations = 'page_integrations',
  PageApi = 'page_api',
  PageResources = 'page_resources',
  PageLibraries = 'page_libraries',
  PageVoices = 'page_voices',
  PageAccountSubscription = 'page_account_subscription',
  PageAccountTeam = 'page_account_team',
  PageAccountBilling = 'page_account_billing',
  PageAccountSettings = 'page_account_settings',
  PageAccountDetails = 'page_account_details',
  PageInsights = 'page_insights',
  /**
   * Folders
   */
  Folders = 'folders',
  /**
   * Team members
   */
  TeamMemberInvitation = 'team_member_invitations',
  TeamMembers = 'team_members',
  /**
   * Team
   */
  TeamVoices = 'team_voices',
  TeamSSO = 'team_sso',
  TeamSeats = 'team_seats',
  /**
   * Respellings and Replacements
   */
  TeamReplacements = 'team_replacements',
  TeamLibrary = 'team_library',
  RespellingSuggestions = 'respelling_suggestions',
  PhoneticReplacement = 'phonetic_replacement',
  /**
   * Billing
   */
  AccountBilling = 'account_billing',
  /**
   * Support
   */
  SupportChat = 'support_chat',
  /**
   *
   * TTS
   */
  TtsVersions = 'tts_versions',
  /*
   * LLM Features
   */
  LlmPronunciations = 'llm_pronunciations',
  LlmRephrase = 'llm_rephrase',
  LlmTranslation = 'llm_translation',
  LlmVoiceAudition = 'llm_voice_audition',
  SmartImport = 'smart_import',
  /**
   * Audio
   */
  AudioFiles = 'audio_files',
  /*
   * API Access
   */
  ApiKeyRequest = 'api_key_request',
  /**
   * Script first
   */
  ImportScript = 'import_script',
  Sections = 'sections',
  Takes = 'takes',
  VariableSampleRate48kHz = 'variable_sample_rate_48000',
  VariableSampleRate96kHz = 'variable_sample_rate_96000',
  PreviewModel = 'preview_model',
  /**
   * Interal debug support feature
   */
  Debug = 'debug',
}

export const SubscriptionTypes = {
  WslAdmin: 'wslAdmin',
  Producer: 'producer',
  Maker: 'maker',
  Creative: 'creative',
  Trial: 'trial',
  Team: 'team',
} as const;
